<template>
  <SFDropdown
    id="sort-selection-dropdown"
    data-testid="sort-dropdown"
    class="h-9 w-full md:w-[12.5rem]"
    :items="sortLinks"
  >
    <template #default>
      <span class="max-w-[80%] overflow-hidden text-ellipsis !text-base">
        {{ selectedSort && $t(selectedSort.label) }}
      </span>
    </template>
    <template #item="{ item, selectItem }">
      <SFLocalizedLink
        :data-testid="`sort-item-${item.key}`"
        variant="whisper"
        class="mb-1 w-full rounded p-2 !text-base !font-medium last-of-type:mb-0 hover:bg-gray-100 focus-visible:shadow-inner-solid-sm"
        :class="{
          'bg-gray-100 !text-anthracite-800': item.key === selectedSort?.key,
        }"
        :to="item.to"
        @click="
          () => {
            selectItem(item)
            trackFilterApply(item.key)
          }
        "
      >
        <span class="flex w-full items-center justify-between">
          {{ $t(item.label) }}
          <IconCheck
            v-if="item.key === selectedSort?.key"
            class="size-4 text-accent"
          />
        </span>
      </SFLocalizedLink>
    </template>
  </SFDropdown>
</template>

<script setup lang="ts">
import {
  APISortOption,
  APISortOrder,
  type Category,
} from '@scayle/storefront-nuxt'
import { useProductListSort } from '@scayle/storefront-product-listing/composables'
import { computed } from 'vue'
import SFLocalizedLink from '../SFLocalizedLink.vue'
import { useTrackingEvents } from '~/composables'
import { SFDropdown } from '#storefront-ui/components'
import { useRoute } from '#app/composables/router'

const { trackFilterApply } = useTrackingEvents()

const route = useRoute()

const { category } = defineProps<{
  category: Category
}>()

const CUSTOM_SORTING_KEY = computed(() => {
  return {
    key: `${category?.countryLevelCustomData.sortingKey || 'top_seller'}`,
    sortingKey: `${
      category?.countryLevelCustomData.sortingKey || 'scayle:v1:top_seller'
    }`,
    direction: (category?.countryLevelCustomData.sortingKey as string)
      ? APISortOrder.ASCENDING
      : APISortOrder.DESCENDING,
  }
})

const { selectedSort, sortLinks } = useProductListSort(route, {
  defaultSortingKey: CUSTOM_SORTING_KEY.value.sortingKey,
  sortingOptions: [
    {
      key: CUSTOM_SORTING_KEY.value.key,
      sortingKey: CUSTOM_SORTING_KEY.value.sortingKey,
      direction: CUSTOM_SORTING_KEY.value.direction,
      label: 'sorting_select.top_seller',
    },
    {
      key: 'date_newest',
      by: APISortOption.DATE_ADDED,
      direction: APISortOrder.DESCENDING,
      label: 'sorting_select.date_newest',
    },
    {
      key: 'price_desc',
      by: APISortOption.PRICE,
      direction: APISortOrder.DESCENDING,
      label: 'sorting_select.price_desc',
    },
    {
      key: 'price_asc',
      by: APISortOption.PRICE,
      direction: APISortOrder.ASCENDING,
      label: 'sorting_select.price_asc',
    },
    {
      key: 'reduction_desc',
      by: APISortOption.REDUCTION,
      direction: APISortOrder.DESCENDING,
      label: 'sorting_select.reduction_desc',
    },
  ],
})
</script>
